import {
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  input,
  computed
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { HashMap } from '@zerops/zef/core';
import { ServiceStackNextDefaultValue, ServiceStackTypes, ServiceStackType } from '@zerops/models/service-stack';
import { ServiceStackCategories } from '@zerops/zerops/core/service-stack-base';
import { ZefProgress } from '@zerops/zef/progress';
import { ServiceStackTypeFieldTranslations } from './service-stack-type-field.translations';

@Component({
  selector: 'z-service-stack-type-field',
  templateUrl: './service-stack-type-field.component.html',
  styleUrl: './service-stack-type-field.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ServiceStackTypeFieldComponent),
      multi: true
    }
  ]
})
export class ServiceStackTypeFieldComponent implements ControlValueAccessor {

  quickAddDisableTypesMap = {
    [ServiceStackTypes.Golang]: true,
    [ServiceStackTypes.Nginx]: true,
    [ServiceStackTypes.Ubuntu]: true,
    [ServiceStackTypes.NodeJs]: true,
    [ServiceStackTypes.Bun]: true,
    [ServiceStackTypes.Deno]: true,
    [ServiceStackTypes.Java]: true,
    [ServiceStackTypes.PhpApache]: true,
    [ServiceStackTypes.PhpNginx]: true,
    [ServiceStackTypes.DotNet]: true,
    [ServiceStackTypes.Rust]: true,
    [ServiceStackTypes.Python]: true,
    [ServiceStackTypes.Ruby]: true,
  };
  serviceStackTypes = ServiceStackTypes;
  serviceStackCategories = ServiceStackCategories;

  items = input<{ item: ServiceStackType, matches: any }[]>();
  serviceStackCategoryTextMap = input<Record<string, string>>({});
  serviceStackCategoryMap = input<Record<string, string>>({});
  itemsByCategory = computed(() => {
    const categoryIndexMap = {};
    const categoryMap = this.serviceStackCategoryMap();

    return this.items()?.reduce((arr, matchItem) => {

      const item = matchItem.item;
      if (!arr[categoryIndexMap[categoryMap[item.id]]]) {
        categoryIndexMap[categoryMap[item.id]] = arr.length;

        arr.push({
          category: categoryMap[item.id],
          items: []
        });
      }

      arr[categoryIndexMap[categoryMap[item.id]]].items.push(matchItem);

      return arr;
    }, []);

  });

  @Input()
  nextDefaultValueMap: HashMap<ServiceStackNextDefaultValue> = {};

  @Input()
  translations: ServiceStackTypeFieldTranslations;

  @Input()
  quickAddLoadingMap: Record<string, ZefProgress>;

  @Output()
  quickAdd = new EventEmitter<ServiceStackNextDefaultValue>();

  @Output()
  selected = new EventEmitter<ServiceStackNextDefaultValue>();

  set value(v) {
    this._value = v;

    this._propagateChange(this.value);
  }

  get value() {
    return this._value;
  }

  private _value: string;

  writeValue(val: string) {
    this.value = val;
  }

  registerOnChange(fn: any) {
    this._propagateChange = fn;
  }

  registerOnTouched(_: any) {
    return;
  }

  private _propagateChange = (_: any) => {
    return;
  };

  trackBy(index: number) {
    return index;
  }
}
